import React from 'react';
type ImageSlotProps = {
  name: string;
  aspect: string;
  src?: string;
  eager?: boolean;
  className?: string;
};
export function ImageSlot({
  name,
  aspect,
  src,
  eager = false,
  className = ''
}: ImageSlotProps) {
  if (src) {
    return <div className={`w-full ${aspect} ${className}`} data-id="element-13" data-mp="29gprf3h9fu6x">
        <img src={src} alt={name} loading={eager ? 'eager' : 'lazy'} decoding="async" className="h-full w-full object-contain" data-id="element-14" data-mp="2ehnb5khx4waj" />
      </div>;
  }
  return <div role="img" aria-label={name} className={`flex w-full items-center justify-center border border-dashed border-gold/70 bg-[#141317] ${aspect} ${className}`} data-id="element-15" data-mp="2oe9to2mrvb9e">
      <span className="px-6 text-center font-serif text-2xl italic text-gold/90" data-id="element-16" data-mp="2x7v7njr44ohr">{name}</span>
    </div>;
}